import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphAxisLines } from './';

export const graphOverviewAxis = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  const axisLines = graphAxisLines(theme, parameters);
  return {
    lineColor: axisLines.lineColor,
    lineThickness: axisLines.lineThickness,
  };
};
